import { TrialProgressCard } from 'assets/js/pages/contacts/data-hygiene/TrialProgressCard';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const NUM_OF_SCANS = 2; // NOTE: addresses has 2 scans for progress count

const AddressesTrialProgressCard = () => {
    const { dataHygiene, isCurrentlyOnFreeTrial } = useCurrentAccount();
    const freeTrialScans = dataHygiene.free_trial_scans;

    if (!isCurrentlyOnFreeTrial || !freeTrialScans) {
        return null;
    }

    const addressesScans = freeTrialScans.addresses;
    const total = freeTrialScans.max_count * NUM_OF_SCANS;
    const progress = addressesScans.deliverability.count + addressesScans.ncoa.count;

    return (
        <TrialProgressCard progress={progress} total={total} visibleTotal={total / NUM_OF_SCANS} />
    );
};

export { AddressesTrialProgressCard };
